"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const device_1 = require("../../../../device");
exports.Info = styled_components_1.default.div `
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  line-height: 1.25;
  color: #fff;

  @media ${device_1.device.tablet} {
    display: none;
  }
`;
exports.MenuButton = styled_components_1.default.button `
  @media ${device_1.device.tablet} {
    display: none;
  }
  color: #fff;
`;
exports.HeaderTitle = styled_components_1.default.div `
  border-bottom: 1px solid #fff;
`;
exports.HeaderUsername = styled_components_1.default.div `
  text-align: right;
`;
